import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const IconButton = withStyles({
  root: {
    backgroundColor: '#2196F3',
    border: '2px solid #2196F3',
    alignSelf: 'flex-start',
    height: 'min-content',
    color: 'white',
    margin: '0.5em',
    boxShadow: 'none',
    '& label': {
      padding: '6px 8px'
    },
    '&:hover': {
      backgroundColor: '#0069d9',
      borderColor: '#0062cc',
      boxShadow: 'none'
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: '#0062cc',
      borderColor: '#005cbf'
    },
    '&:disabled': {
      color: '#00000052 !important',
      backgroundColor: '#c7cfd6 !important',
      borderColor: '#c7cfd6 !important'
    }
  }
})(Button);

const BlueIconButton = ({icon, text, onClick, matchSize, isDisabled}) => {
  const matches = useMediaQuery(`(min-width:${matchSize}px)`);

  return (
    <IconButton data-testid="blue-icon-button" disabled={isDisabled} startIcon={matches && <Icon>{icon}</Icon>} onClick={onClick}>
      {!matches && <Icon>{icon}</Icon> }
      {matches && <span>{text}</span>}

    </IconButton>
  );
};

BlueIconButton.propTypes = {
  icon: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  matchSize: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool
};

export default BlueIconButton;
